import { useState } from 'react';
import { EqualizerLoader } from './EqualizerLoader';
import { SalsaLoader } from './SalsaLoader';
import { CountInLoader } from './CountInLoader';
import { ZoukLoader } from './ZoukLoader';
import { BachataLoader } from './BachataLoader';
import { KizombaLoader, KizombaStepLoader, KizombaMarcaLoader } from './KizombaLoaders';
import { useDanceStyleLoaderStyles } from './DanceStyleLoaderContext';
import {
  RANDOM_LOADER_POOL,
  loaderPoolForStyles,
  type DanceLoaderType,
  type DanceStyleLike,
} from '../../../src/constants/danceLoaders';

interface DanceLoaderProps {
  type?: DanceLoaderType;
  // Pick a loader that matches these styles. Falls back to the page's
  // DanceStyleLoaderProvider, then to a random loader.
  danceStyles?: DanceStyleLike[];
}

export function DanceLoader({ type, danceStyles }: DanceLoaderProps) {
  const pageStyles = useDanceStyleLoaderStyles();
  const [picked] = useState<DanceLoaderType>(() => {
    if (type) return type;
    const matched = loaderPoolForStyles(danceStyles);
    const pool = matched.length ? matched : loaderPoolForStyles(pageStyles);
    const choices = pool.length ? pool : RANDOM_LOADER_POOL;
    return choices[Math.floor(Math.random() * choices.length)];
  });

  switch (picked) {
    case 'equalizer':     return <EqualizerLoader />;
    case 'salsa':         return <SalsaLoader />;
    case 'count-in':      return <CountInLoader />;
    case 'zouk':          return <ZoukLoader />;
    case 'bachata':       return <BachataLoader />;
    case 'kizomba':       return <KizombaLoader />;
    case 'kizomba-step':  return <KizombaStepLoader />;
    case 'kizomba-marca': return <KizombaMarcaLoader />;
  }
}
